/*
 * Copyright (c) 2023 Limpide
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a copy of
 *  this software and associated documentation files (the "Software"), to deal in
 *  the Software without restriction, including without limitation the rights to
 *  use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 *  the Software, and to permit persons to whom the Software is furnished to do so,
 *  subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included in all
 *  copies or substantial portions of the Software.
 *
 *  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 *  FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 *  COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 *  IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 *  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import Marquer from '@scripts/marquer'

export default class MessageHandler {
    origin?: string = 'https://accueil.maratp.fr'

    start() {
        window.addEventListener(
            'message',
            (event: MessageEvent<any>) => {
                const marquers: Marquer = new Marquer(window.layerData.data_layer)
                const pageLink = marquers.get_page_link()
                let pageType: string = ''
                let pageTypeFindTerme: string | null = null
                const pageTypeFindPage = marquers.marquerLayers
                    ? marquers.find_page(marquers.marquerLayers.type_page, pageLink)
                    : null

                if (marquers.get_post_category()) {
                    const category = marquers.get_post_category()

                    pageTypeFindTerme = marquers.marquerLayers
                        ? marquers.find_terme(marquers.marquerLayers.type_page, category)
                        : null
                }

                if (pageTypeFindPage) {
                    pageType = pageTypeFindPage
                } else if (pageTypeFindTerme) {
                    pageType = pageTypeFindTerme
                }

                if (this.origin && event.origin === this.origin) {
                    switch (event.data) {
                        case 'form-loaded':
                            console.log('----- receive message: form-loaded')
                            break

                        case 'form-submitted':
                            console.log('----- receive message: form-submitted')
                            window.dataLayer.push({
                                event: 'click.action',
                                click: marquers.find_qualifio_cta('inscriptionNewsletterSucess'),
                                click_chapter1: pageType
                            })
                            break

                        case 'customisation-newsletter':
                            console.log('----- customisation-newsletter')
                            window.dataLayer.push({
                                event: 'click.action',
                                click: marquers.find_qualifio_cta('personnalisationNewsletter'),
                                click_chapter1: pageType
                            })
                            break

                        case 'form-end':
                            console.log('----- receive message: form-end')
                            break

                        case 'inscription-jeux-concours':
                            console.log('----- receive message: inscription-jeux-concours')
                            window.dataLayer.push({
                                event: 'click.action',
                                click: marquers.find_qualifio_cta('inscriptionJeuxConcours'),
                                click_chapter1: pageType
                            })
                            break

                        default:
                            break
                    }
                }
            },
            false
        )
    }
}
